module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-ring-2-c2ce89d681e019a60427888438686d88.svg";